import axios from 'axios';
import { saveDraft } from './draftRecovery';

let draftSaveCallback = null;
let userIdGetter = null;
let currentRouteGetter = null;

// Setup axios interceptor for handling 401 errors
export const setupAxiosInterceptor = (getUserId, getCurrentRoute, onSessionExpired) => {
  userIdGetter = getUserId;
  currentRouteGetter = getCurrentRoute;
  draftSaveCallback = onSessionExpired;

  // Response interceptor
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // Check if it's a 401 error and not already retried
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        // Try to get any form data that might be in the request
        let formData = null;
        try {
          if (originalRequest.data) {
            formData = typeof originalRequest.data === 'string' 
              ? JSON.parse(originalRequest.data) 
              : originalRequest.data;
          }
        } catch (e) {
          console.error('Could not parse request data for draft:', e);
        }

        // Get user ID and current route
        const userId = userIdGetter ? userIdGetter() : null;
        const route = currentRouteGetter ? currentRouteGetter() : window.location.pathname;

        // Save draft if we have form data and user ID
        if (formData && userId) {
          saveDraft(formData, userId, route);
          console.log('Draft saved due to session expiration');
        }

        // Call the session expired callback
        if (draftSaveCallback) {
          draftSaveCallback();
        }
      }

      return Promise.reject(error);
    }
  );
};

// Method to manually trigger draft save (can be called before API requests)
export const triggerDraftSave = (formData) => {
  const userId = userIdGetter ? userIdGetter() : null;
  const route = currentRouteGetter ? currentRouteGetter() : window.location.pathname;
  
  if (formData && userId) {
    saveDraft(formData, userId, route);
  }
};
